import { FC, useState, createContext, useContext } from 'react';
import noop from 'lodash/noop';
import { ALERT_TYPES, ALERT_MESSAGE } from 'config/constants';
import { Amendment } from 'types';
import { useDetailsBooking, useActions } from 'lib/hooks';
import { trackUpdatedValue, trackEditDetailsPopUp, FormValues } from './tracking';
import { useSoftAmendment } from '../lib/useSoftAmendment';

interface ContextValue {
  onSubmit: Function;
  loading: Boolean;
  complete: Boolean;
  amendment?: Amendment;
  error?: Error;
}

export const SoftAmendmentContext = createContext<ContextValue>({
  onSubmit: noop,
  loading: false,
  complete: false,
});

export const SoftAmendmentProvider: FC = ({ children }) => {
  const { booking, refetch } = useDetailsBooking();
  const { createAndAcceptSoftAmendment, loading, error } = useSoftAmendment();
  const [amendment, setAmendment] = useState<Amendment>();
  const [complete, setComplete] = useState(false);
  const {
    alert: { displayAlert },
  } = useActions();

  const bookingDetails = {
    email: booking.travelArranger.email,
    phone: booking.travelArranger.phone,
    qffNumber: booking.reservation.qffEarnNumber,
    businessNumber: booking.travelArranger.businessRegistrationNumber,
  };

  const onSubmit = async ({ name, ...values }: FormValues) => {
    const completedAmendment = await createAndAcceptSoftAmendment({ bookingId: booking.id, input: values });
    setAmendment(completedAmendment);

    if (completedAmendment) {
      trackUpdatedValue(bookingDetails, values);
      trackEditDetailsPopUp();
      refetch();
      displayAlert({ type: ALERT_TYPES.SUCCESS, message: ALERT_MESSAGE.AMENDMENT_SUCCESS });
      setComplete(true);
    }
  };

  return (
    <SoftAmendmentContext.Provider value={{ onSubmit, amendment, complete, loading, error }}>{children}</SoftAmendmentContext.Provider>
  );
};

export const useSoftAmendmentContext = () => useContext(SoftAmendmentContext);
